import React, { useState, useEffect } from "react";
import Media from "react-media";
import { IconBoxReusableSeatingComponent } from "../../../reusableComponents/IconBoxReusable/IconBoxReusableComponent";
import { useSelector } from "react-redux";
import axios from "axios";
import { serverApi } from "../../../../config/Keys";

const SeatingDashboardLeft = (props) => {
  const pendingTotal = useSelector(
    (state) => state.allDinerDetails.vendor_all_pending_diner.total
  );
  const walkinTotal = useSelector(
    (state) => state.allDinerDetails.vendor_all_diner.total
  );
  const authUser = useSelector((state) => state.auth.user);
  const reservation = useSelector(
    (state) => state.allDinerDetails.vendor_all_reservation_diner
  );
  const [reservationTotal, setReservationTotal] = useState(0);

  useEffect(() => {
    async function reservationData() {
      let data = await axios.get(
        `${serverApi}/diner?vendor_id=${authUser.VendorUser._id}&diner_status=RESERVATION&openAll=true`,
        {
          headers: {
            Authorization: authUser.accessToken,
            "Content-Type": "application/json",
          },
        }
      );
      if (data?.data) {
        setReservationTotal(data.data.total);
      }
    }
    reservationData();
  }, [reservation]);
  const seatingNew = require("../../../../assets/images/seatingImages/newseaticon.svg");
  const pendingNew = require("../../../../assets/images/seatingImages/newpendingicon.svg");
  const reservationNew = require("../../../../assets/images/seatingImages/newreservationicon.svg");
  const historyNew = require("../../../../assets/images/seatingImages/newhistoryicon.svg");
  const pendingWhite = require("../../../../assets/images/seatingImages/emailWhite.png");
  const pendingDark = require("../../../../assets/images/seatingImages/emailBlack.png");
  const seatingWhite = require("../../../../assets/images/seatingImages/seating-white.svg");
  const seatingDark = require("../../../../assets/images/seatingImages/seatingGray.svg");
  const reservationWhite = require("../../../../assets/images/seatingImages/reservationWhite.png");
  const reservationDark = require("../../../../assets/images/seatingImages/reservationBlack.png");
  const historyWhite = require("../../../../assets/images/seatingImages/historyWhite.png");
  const historyDark = require("../../../../assets/images/seatingImages/historyBlack.png");
  return (
    <React.Fragment>
      <div className="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4 seating-left-side-navigation">
        <div className="row">
          <div className="col-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 text-center">
            <IconBoxReusableSeatingComponent
              classSection={
                props.selectedPage === 2
                  ? "newseating-dashboard-reusable-button newseating-dashboard-reusable-button-active"
                  : "newseating-dashboard-reusable-button"
              }
              imageStyle="inside-image-button"
              src={pendingNew}
              iconText="Pending"
              iconTextStyle={
                props.selectedPage === 2
                  ? "icon-bottom-text icon-bottom-text-active"
                  : "icon-bottom-text"
              }
              link="/pendingdashboard"
              bedgeClass="badge custom-icon-button-badge custom-badge-position-pending"
              displayNotification={true}
              notificationCount={pendingTotal}
              bottomLine={props.selectedPage === 2 ? "bottom-box-line" : null}
            />
          </div>
          <div className="col-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 text-center">
            <IconBoxReusableSeatingComponent
              classSection={
                props.selectedPage === 1
                  ? "newseating-dashboard-reusable-button newseating-dashboard-reusable-button-active"
                  : "newseating-dashboard-reusable-button"
              }
              // imageStyle="inside-image-button-seat"
              src={seatingNew}
              iconText="Seating"
              iconTextStyle={
                props.selectedPage === 1
                  ? "icon-bottom-text icon-bottom-text-active"
                  : "icon-bottom-text"
              }
              link="/seatingdashboard"
              bottomLine={props.selectedPage === 1 ? "bottom-box-line" : null}
              bedgeClass="badge custom-icon-button-badge custom-badge-position-seating"
              displayNotification={true}
              notificationCount={walkinTotal}
            />
          </div>
          <div className="col-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 p-0 text-center">
            <IconBoxReusableSeatingComponent
              classSection={
                props.selectedPage === 3
                  ? "newseating-dashboard-reusable-button newseating-dashboard-reusable-button-active"
                  : "newseating-dashboard-reusable-button"
              }
              imageStyle="inside-image-button"
              src={
                reservationNew
              }
              iconText="Reservations"
              iconTextStyle={
                props.selectedPage === 3
                  ? "icon-bottom-text icon-bottom-text-active"
                  : "icon-bottom-text"
              }
              link="/reservationdashboard"
              bedgeClass="badge custom-icon-button-badge custom-badge-position-reservation"
              displayNotification={true}
              notificationCount={reservationTotal}
              bottomLine={props.selectedPage === 3 ? "bottom-box-line" : null}
            />
          </div>
          <div className="col-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 text-center">
            <IconBoxReusableSeatingComponent
              classSection={
                props.selectedPage === 4
                  ? "newseating-dashboard-reusable-button newseating-dashboard-reusable-button-active"
                  : "newseating-dashboard-reusable-button"
              }
              imageStyle="inside-image-button"
              src={historyNew}
              iconText="History"
              iconTextStyle={
                props.selectedPage === 4
                  ? "icon-bottom-text icon-bottom-text-active"
                  : "icon-bottom-text"
              }
              link="/historydashboard"
              bottomLine={props.selectedPage === 4 ? "bottom-box-line" : null}
            />
          </div>
        </div>
        {/* <div className="container-fluid">
            <div className="row">
              <div className="col-3 col-sm-3 col-md-3 col-lg-3 col-xl-3">
                <IconBoxReusableSeatingComponentText
                  iconText="Pending"
                  iconTextStyle={
                    props.selectedPage === 2
                      ? "icon-bottom-text icon-bottom-text-active"
                      : "icon-bottom-text"
                  }
                  link="/pendingdashboard"
                  bottomLine={
                    props.selectedPage === 2 ? "bottom-box-line" : null
                  }
                />
              </div>
              <div className="col-3 col-sm-3 col-md-3 col-lg-3 col-xl-3">
                <IconBoxReusableSeatingComponentText
                  iconText="Seating"
                  iconTextStyle={
                    props.selectedPage === 1
                      ? "icon-bottom-text icon-bottom-text-active"
                      : "icon-bottom-text"
                  }
                  link="/seatingdashboard"
                  bottomLine={
                    props.selectedPage === 1 ? "bottom-box-line" : null
                  }
                />
              </div>
              <div className="col-3 col-sm-3 col-md-3 col-lg-3 col-xl-3">
                <IconBoxReusableSeatingComponentText
                  iconText="Reservations"
                  iconTextStyle={
                    props.selectedPage === 3
                      ? "icon-bottom-text icon-bottom-text-active"
                      : "icon-bottom-text"
                  }
                  link="/reservationdashboard"
                  bottomLine={
                    props.selectedPage === 3 ? "bottom-box-line" : null
                  }
                />
              </div>
              <div className="col-3 col-sm-3 col-md-3 col-lg-3 col-xl-3">
                <IconBoxReusableSeatingComponentText
                  iconText="History"
                  iconTextStyle={
                    props.selectedPage === 4
                      ? "icon-bottom-text icon-bottom-text-active"
                      : "icon-bottom-text"
                  }
                  link="/historydashboard"
                  bottomLine={
                    props.selectedPage === 4 ? "bottom-box-line" : null
                  }
                />
              </div>
            </div>
          </div> */}
        <Media query="(min-width: 992px)">
          <div className="col-12 p-0">
            <hr className="mobile-device-line" />
          </div>
        </Media>
      </div>
    </React.Fragment>
  );
};

export default SeatingDashboardLeft;
